/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import "twin.macro";
import { Button, Modal } from "antd";
import { btnStyle } from "../../lib/styles/styleLibrary";
import { Loading } from "../Loading/Loading";
import OTPInput from "otp-input-react";
import { ModalContainer, ModalTitle } from "./component";
import { Toast } from "../../lib/helpers/helpers";

const PinInput = ({
	pin,
	confirmPinInput,
	isVisible,
	loading,
	title,
	setPin = () => {
		return null;
	},
	goBack = () => {
		return null;
	},
	continueTask = () => {
		return null;
	},
}) => {
	const [disabled, setDisabled] = useState(true);
	const [firstPin, setFirstPin] = useState("");
	const [pinConfirm, setPinConfirm] = useState("");

	useEffect(() => {
		if (confirmPinInput) {
			return pinConfirm?.length < 4
				? setDisabled(true)
				: setDisabled(false);
		}
		return pin?.length < 4 ? setDisabled(true) : setDisabled(false);
	}, [pin, pinConfirm, confirmPinInput]);
	return (
		<Modal
			footer=""
			visible={isVisible}
			centered
			destroyOnClose={true}
			onCancel={() => {
				goBack();
				setPin("");
				setFirstPin("");
				setPinConfirm("");
			}}
			maskClosable={false}>
			<ModalContainer>
				<ModalTitle tw="px-8 opacity-60 text-base m-0!">
					{title}
				</ModalTitle>
				<ModalTitle>Enter transaction PIN</ModalTitle>
				<div
					className="inputWrapper"
					tw="flex flex-row justify-center items-center">
					<OTPInput
						value={confirmPinInput ? firstPin : pin}
						onChange={(v) => {
							confirmPinInput ? setFirstPin(v) : setPin(v);
						}}
						OTPLength={4}
						otpType="number"
						// inputStyle={{ otpStyle }}
						placeholder={"----"}
						secure
					/>
				</div>
				{confirmPinInput && firstPin.length > 3 && (
					<>
						<ModalTitle tw="mt-8">
							Confirm transaction PIN
						</ModalTitle>
						<div
							className="inputWrapper"
							tw="flex flex-row justify-center items-center">
							<OTPInput
								value={pinConfirm}
								onChange={(v) => {
									setPinConfirm(v);
								}}
								autoFocus
								OTPLength={4}
								otpType="number"
								// inputStyle={{ otpStyle }}
								placeholder={"----"}
								secure
							/>
						</div>
					</>
				)}

				<div tw="mt-8">
					<Button
						disabled={disabled}
						onClick={() => {
							if (confirmPinInput) {
								if (firstPin !== pinConfirm) {
									return Toast.fire({
										icon: "error",
										title: "Pin inputs do not match...",
									});
								}
								setPin(pinConfirm);
							}

							continueTask();
							setFirstPin("");
							setPinConfirm("");
						}}
						css={btnStyle}
						tw="rounded-lg flex text-white flex-row flex-nowrap items-center justify-center gap-1 tracking-wider">
						{loading ? <Loading /> : <span>Confirm</span>}
					</Button>
				</div>
			</ModalContainer>
		</Modal>
	);
};

export default PinInput;
